<template>
	<div class="main_page contactUs_page" ref="middle_page">
		<span class="contactUs_span"></span>
		<div class="contactUs_box">
			<div v-if="send_show == 'init'" class="contactUs_content">
				<p class="contactus">{{$t('contactUs.contactUs')}}</p>
				<input ref="email" class="input" v-model="email" :placeholder="$t('contactUs.email')"/>
				<textarea class="input2" :placeholder="$t('contactUs.problem')" v-model="content" maxlength="1000" style="resize:none" />
        <div class="btn_div">
          <button round class="back_home_btn" @click="send">{{$t('contactUs.send')}}</button>
          <button round class="back_home_btn go_home_btn" @click="back_home">{{$t('common.returnButton')}}</button>
        </div>
			</div>
			<div v-if="send_show == 'success'" class="contactUs_content">
				<p class="send_success">{{$t('contactUs.sucess')}}</p>
				<p class="order_number">{{$t('contactUs.sure')}}：{{orderNum}}</p>
				<p class="sorry">{{$t('contactUs.sorry')}}</p>
				<el-button round class="send_btn send_btn2" @click="back_home">{{$t('contactUs.gohome')}}</el-button>
			</div>
      <div v-if="send_show == 'fail'" class="contactUs_content">
        <p class="send_success">{{$t('contactUs.faild')}}</p>
        <p class="sorry">{{$t('contactUs.sever')}}</p>
        <el-button round class="send_btn" @click="resend">{{$t('contactUs.resend')}}</el-button>
      </div>
		</div>
	</div>
</template>

<script>
	export default {
	  props:['userId'],
	  name: 'ContactUs',
	  data () {
	    return {
			  send_show:"init",
			  email:'',
        content:null,
        orderNum:null
	    }
	  },
// 	  created() {
// 	  	document.documentElement.scrollTop = 0
// 	  },
    mounted(){
	    //显示顶部
      scrollTo(0,0);
	  //获取设备屏幕的高度
	  const h = document.body.clientHeight-299
	  // this.$refs.middle_page.style.minHeight = h + "px";
	  this.$refs.email.readOnly = false;
      this.$autoLogin().then(
        ()=>{
		  this.email = window.sessionStorage.getItem("email");
		  this.userId = window.sessionStorage.getItem("id");
		  this.$refs.email.readOnly = 'readonly';
        },()=>{
          //无操作
          this.userId = "tourist";
        }
      )
    },
	  methods:{
		   send:function(){
         if(this.email == ""){
           this.$el_alert_type(window.vm.$i18n.t('js.email'),'warning');
           return;
         }
         //邮箱验证
         let reg=new RegExp(/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/);
         if(!reg.test(this.email)){
           this.$el_alert_type(window.vm.$i18n.t('js.formatWrong'),'warning');
           return;
         }
         //内容校验
         if(this.content == null ||this.content == ''){
           this.$el_alert_type(window.vm.$i18n.t('js.problemInput'),'warning');
           return;
         }
         this.$api.post("/home/contactUs",{"email":this.email,"contactContent":this.content}).then(
           (response)=> {
           this.orderNum = response.data;
           this.send_show = "success";
         }).catch(()=>{
             this.send_show = "fail"
          }
         )
         scrollTo(0,0);
		   },
		   back_home:function(){
			   this.$router.replace("/")
		   },
       resend:function(){
		     this.send_show = "init";
       },
	  }

	}
</script>

<style scoped="scoped">
	.contactUs_page{
		position: relative;
		background: url(../../../static/images/bg/personset_bg2.jpg);
		background-size: cover;
		position: relative;
		width: 100%;
		/*min-width: 1200px;*/
	}
	.contactUs_span {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: rgba(0, 0, 0, .5);
	}
	.contactUs_box{
		padding:100px 0 60px;
	}
	.contactUs_content{
		width: 413px;
		/*min-height: 200px;*/
		margin:0px auto;
		background-color: rgba(0,0,0,0.6);
		border-radius: 15px;
		display: grid;
		z-index: 2;
		position: relative;
	}
	.contactUs_content .contactus{
		height: 30px;
		line-height: 30px;
		margin-top:30px;
		font-size: 25px;
		color: rgb(250, 250, 250);
		/* font-family: museo-slab-w01-100,serif; */
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		text-align: center;
	}
	.contactUs_content .input{
		width: 340px;
		height: 31px;
		line-height: 31px;
		padding-bottom:2px;
		margin: 0 auto;
		margin-top:30px;
		font-size: 14px;
		color: rgb(232, 230, 230);
		/* font-family: lato-light,lato,sans-serif; */
		text-align: left;
		background-color: rgba(153, 153, 151, 0.35);
		border-radius:20px;
		text-indent: 15px;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		outline: none;
		border:1px solid rgba(0,0,0,0.6);
	}
	.contactUs_content .input2{
		width: 296px;
		height: 275px;
		margin: 0 auto;
		margin-top:20px;
		line-height: 20px;
		background-color: rgba(153, 153, 151, 0.35);
		border-radius:10px;
		border:1px solid rgba(0,0,0,0.6);
		font-size: 14px;
		color: rgb(232, 230, 230);
		/* font-family: museo-slab-w01-100,serif; */
		padding: 20px;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		outline: none;
	}
	.contactUs_content .send_btn{
		/* height: 25px; */
		line-height: 25px;
		background-color: unset;
		font-size: 12px;
		color: rgb(232, 230, 230);
		/* font-family:  barlow-extralight, barlow, sans-serif; */
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		border: 1px #fff solid;
		padding:0 20px 2px 20px !important;
		margin: 0 auto;
		margin-top:30px;
		margin-bottom:30px;
		transition: 0.5s ease;
	}
	.contactUs_content .send_btn2{
		margin-top:0px;
		margin-bottom:80px;
	}
	.contactUs_content .send_btn:hover{
		background-color: #fff;
		color:#000;
		transition: 0.5s ease;
	}
	.contactUs_content .send_success{
		height: 30px;
		line-height: 30px;
		margin-top:60px;
		font-size: 43px;
		color: #FAFAFA;
		/* font-family: museo-slab-w01-100,serif; */
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		text-align: center;
		font-weight: bold;
	}
	.contactUs_content .order_number{
		height: 10px;
		line-height: 10px;
		margin-top:20px;
		font-size: 15px;
		color: rgb(250, 250, 250);
        /* font-family: museo-slab-w01-100,serif; */
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		text-align: center;
	}
	.contactUs_content .sorry{
		margin-top:50px;
		margin-bottom:60px;
		font-size: 17px;
		color: rgb(250, 250, 250);
		/* font-family: museo-slab-w01-100,serif; */
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		text-align: center;
		padding:0 65px 0 65px;
	}
  .contactUs_content .btn_div{
    text-align: center;
  }
  .contactUs_content .back_home_btn{
    height: 25px;
    line-height: 25px;
    width: 60px;
    background-color: unset;
    font-size: 12px;
    color: rgb(232, 230, 230);
    font-weight: 200;
    border: 1px #fff solid;
    margin: 30px 10px 30px 10px;
    transition: 0.5s ease;
    display: inline-block;
    border-radius: 12.5px;
  }
  .contactUs_content .back_home_btn:hover{
    background-color: #fff;
    color:#000;
    transition: 0.5s ease;
  }

</style>



// WEBPACK FOOTER //
// src/views/public/ContactUs.vue